import Container from "../Helper/Container";
import images from "../../images";
import Profile from "./Profile/Index";
import SideBarOptions from "./SideBarOptions";
import ThemeSelector from "./ThemeSelector";
import translate from "../../Utils/translate";

export default function Nav() {
  return (
    <nav className="sm:bg-theme-tertiary sm:overflow-y-auto sm:mr-default">
      <Container className="flex justify-end h-full sm:flex-col sm:justify-between">
        <Profile />

        <div className="hidden flex-grow mt-24 sm:block">
          <ul>
            <SideBarOptions active={true} icon={images.icons.lock} text={translate("pages.nav.password")} />
            <SideBarOptions disabled={true} icon={images.icons.note} text={translate("pages.nav.secure_notes")} />
            <SideBarOptions disabled={true} icon={images.icons.card} text={translate("pages.nav.cards")} />
          </ul>

          <ul className="mt-default">
            <h5 className="text-sm font-medium mb-2">{translate("pages.nav.folder.title")}</h5>
            <SideBarOptions disabled={true} icon={images.icons.folder} text={translate("pages.nav.folder.work")} />
            <SideBarOptions disabled={true} icon={images.icons.folder} text={translate("pages.nav.folder.school")} />
            <SideBarOptions disabled={true} icon={images.icons.folder} text={translate("pages.nav.folder.personal")} />
          </ul>
        </div>

        <div className={"hidden bg-theme-secondary rounded-default sm:block"}>
          <ThemeSelector />
        </div>
      </Container>
    </nav>
  );
}
